import React from "react";


const CircleIcon = ({ fill = '#F2610D', size = 20 }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle cx="10" cy="10" r="10" fill={fill} />
    </svg>
  );

const PropositionBlocks = ({ settings, isMobile }) => {
    const { proposition_heading_font_style, proposition_subcopy_font_style } = settings;
    const blocks = [
        {
          title: settings.proposition_title_1,
          description: settings.proposition_description_1,
        },
        {
          title: settings.proposition_title_2,
          description: settings.proposition_description_2,
        },
        {
          title: settings.proposition_title_3,
          description: settings.proposition_description_3,
        },
        {
          title: settings.proposition_title_4,
          description: settings.proposition_description_4,
        },
    ].filter((block) => block.title || block.description);

  return (
    <div className="w-full h-full flex flex-col lg:flex-row mt-[32px] lg:mt-[64px] gap-[28px] lg:gap-[40px]">
      {blocks.map((block, index) => (
        <div
          key={`usp-${index}`}
          className="usp-container justify-start lg:justify-start self-start lg:w-full flex flex-nowrap items-center"
        >
          <div className="flex text-left">
            <div className="usp-content flex flex-col  gap-y-[8px] items-center">
              <div className="flex flex-row  gap-x-2 items-center lg:items-start">
                <div className="w-[20px] h-[20px]"> <CircleIcon fill="#F2610D" />  </div>
                <div className="flex flex-col pl-8 gap-y-[12px]">
                  <div className={`${proposition_heading_font_style}`}>{block.title}</div>
                  <p className={`${proposition_subcopy_font_style}`}>{block.description}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PropositionBlocks;
